import { createContext, useContext } from 'react';

/** Host-supplied preview inputs, independent of editor state and actions. */
export type CardRenderEnvironment = Readonly<{
  /** Null preserves normal viewport rendering, including non-editor previews. */
  previewCanvas: Readonly<{
    device: 'desktop' | 'tablet' | 'mobile';
    presentation: 'default' | 'banner';
  }> | null;
}>;

const CardRenderEnvironmentContext = createContext<CardRenderEnvironment>({
  previewCanvas: null,
});

export const CardRenderEnvironmentProvider =
  CardRenderEnvironmentContext.Provider;

export const useCardRenderEnvironment = (): CardRenderEnvironment =>
  useContext(CardRenderEnvironmentContext);
